import { useCallback, useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, Tooltip } from 'react-leaflet'
import * as L from "leaflet"


const LocationPicker = ({
    locationName,
    latitude,
    longitude,
    onPositionChange,
    markerMoveTracking
}) => {

    console.log("LocationPicker RENDERED")

    const defaultLocation = [41.902782, 12.496366]
    const [map, setMap] = useState(null)

    // const onMove = useCallback(() => {
    //     onPositionChange(map.getCenter())
    // }, [map])

    const onMove = () => {
        onPositionChange(map.getCenter())
    }

    useEffect(() => {
        if (!!map) {
            map.on('move', onMove)
            return () => {
                map.off('move', onMove)
            }
        }

    }, [map, onMove])

    // if (map && map.getCenter().lat != latitude) {
    //     setTimeout(() => {
    //         map.setView((!!latitude && !!longitude ? [latitude, longitude] : defaultLocation), map.getZoom())
    //     }, 1000)
    // }

    var markerSize = { 'sm': [28, 35], 'md': [35, 44], 'lg': [42, 53] };
    var markerAnchor = { 'sm': [14, 35], 'md': [17, 44], 'lg': [21, 53] };
    var markerPopupAnchor = { 'sm': [1, -35], 'md': [1, -44], 'lg': [2, -53] };

    function getMarkerIcon() {
        return new L.Icon({
            iconUrl: `https://assets.mapquestapi.com/icon/v2/marker-lg-2c363c-2bb673-${locationName}.png`,
            iconSize: markerSize.lg,
            iconAnchor: markerAnchor.lg,
            popupAnchor: markerPopupAnchor.lg
        })
    }


    return (
        <div className={markerMoveTracking ? `border border-primary border-4` : undefined}>


            <MapContainer
                ref={setMap}
                center={!!latitude && !!longitude ? [latitude, longitude] : defaultLocation}
                zoom={15}
                scrollWheelZoom={true}
                
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <Marker
                    icon={getMarkerIcon()}
                    position={!!latitude && !!longitude ? [latitude, longitude] : defaultLocation}
                >
                    <Tooltip><b>{locationName}</b></Tooltip>
                </Marker>

            </MapContainer>
        </div>
    )

}

export default LocationPicker